export default __webpack_public_path__ + "static/media/promoHeaderMobile.9091e0e3.png";